// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBn80DXQu8-H8HHl6PzARAlSwv-3aAO1Q0",
  authDomain: "rocharamascnc.firebaseapp.com",
  projectId: "rocharamascnc",
  storageBucket: "rocharamascnc.firebasestorage.app",
  messagingSenderId: "496193550382",
  appId: "1:496193550382:web:efd6d86ba0703e2134c7bf",
  measurementId: "G-QY0VFBBCEQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

